import { render, staticRenderFns } from "./IpRadioManual.vue?vue&type=template&id=140e9634&scoped=true"
import script from "./IpRadioManual.vue?vue&type=script&lang=js"
export * from "./IpRadioManual.vue?vue&type=script&lang=js"
import style0 from "./IpRadioManual.vue?vue&type=style&index=0&id=140e9634&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140e9634",
  null
  
)

export default component.exports